import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
import ScrollTo from "stimulus-scroll-to"
import 'bootstrap.native';
import "glider-js";
import * as Klaro from 'klaro/dist/klaro-no-css';

let application = null

if (module.hot) {
  module.hot.accept() // tell hmr to accept updates

  if (module.hot.data) {
    application = module.hot.data.application // re-use old application if one was passed after update
  }
}

if (!application) {
  application = Application.start() // if no application so far, start it
}

if (module.hot) {
  module.hot.dispose(data => {
    data.application = application // on disposal of the old version (before reload), pass the old application to the new version
  })
}

const context = require.context("./controllers", true, /\.js$/)
application.load(definitionsFromContext(context))
application.register("scroll-to", ScrollTo)

let updateSlider = function() {
  const menu = document.querySelector('.megamenu');
  if (!menu) {
    return;
  }

  menu.classList.add('show');
  if (typeof window.machineGlider != 'undefined') {
    for (let glider of window.machineGlider) {
      glider.refresh(true);
    }
  }
  menu.classList.remove('show');
}

document.addEventListener("DOMContentLoaded", updateSlider);
addEventListener("resize", updateSlider);

// var for global scope
var klaroConfig = {
  storageMethod: 'cookie',
  cookieExpiresAfterDays: 365,
  acceptAll: true,
  default: true,
  hideDeclineAll: false,
  mustConsent: true,
  privacyPolicy: {
    default: '/en/privacy',
    de: '/de/datenschutz',
  },
  translations: {
    de: {
      consentNotice: {
        description: 'Wir verwenden Cookies, um Inhalte und Anzeigen zu personalisieren, Funktionen für soziale Medien anbieten zu können und die Zugriffe auf unsere Website zu analysieren. Außerdem geben wir Informationen zu Ihrer Verwendung unserer Website an unsere Partner für soziale Medien, Werbung und Analysen weiter. Unsere Partner führen diese Informationen möglicherweise mit weiteren Daten zusammen, die Sie ihnen bereitgestellt haben oder die sie im Rahmen Ihrer Nutzung der Dienste gesammelt haben.',
      },
      consentModal: {
        description: 'Wir verwenden Cookies, um Inhalte und Anzeigen zu personalisieren, Funktionen für soziale Medien anbieten zu können und die Zugriffe auf unsere Website zu analysieren. Außerdem geben wir Informationen zu Ihrer Verwendung unserer Website an unsere Partner für soziale Medien, Werbung und Analysen weiter. Unsere Partner führen diese Informationen möglicherweise mit weiteren Daten zusammen, die Sie ihnen bereitgestellt haben oder die sie im Rahmen Ihrer Nutzung der Dienste gesammelt haben.',
      },
      purposes: {
        analytics: 'Analyse',
        content: 'Inhalte',
        ads: 'Werbung',
      },
    },
    en: {
      consentNotice: {
        description: 'We use cookies to personalize content and ads, to provide social media features and to analyze traffic to our website. We also share information about your use of our website with our social media, advertising and analytics partners. Our partners may combine this information with other data that you have provided to them or that they have collected as part of your use of the services.',
      },
      consentModal: {
        description: 'We use cookies to personalize content and ads, to provide social media features and to analyze traffic to our website. We also share information about your use of our website with our social media, advertising and analytics partners. Our partners may combine this information with other data that you have provided to them or that they have collected as part of your use of the services.',
      },
      purposes: {
        analytics: 'Analytics',
        content: 'Content',
        ads: 'Ads',
      },
    }
  },
  services: [
    {
      name: 'youtube',
      purposes: ['content'],
    },
    {
      name: 'google-tag-manager',
      purposes: ['analytics'],
      required: true,
      onAccept: `
                // we notify the tag manager about all services that were accepted. You can define
                // a custom event in GTM to load the service if consent was given.
                for(let k of Object.keys(opts.consents)){
                    if (opts.consents[k]){
                        let eventName = 'klaro-'+k+'-accepted'
                        dataLayer.push({'event': eventName})
                    }
                }
            `,
      onInit: `
                // initialization code here (will be executed only once per page-load)
                window.dataLayer = window.dataLayer || [];
                window.gtag = function(){dataLayer.push(arguments)}
                gtag('consent', 'default', {'ad_storage': 'denied', 'analytics_storage': 'denied', 'ad_user_data': 'denied', 'ad_personalization': 'denied'})
                gtag('set', 'ads_data_redaction', true)
            `,
    },
    {
      name: 'google-analytics',
      purposes: ['analytics'],
      cookies: [
        /^_ga(_.*)?/ // we delete the Google Analytics cookies if the user declines its use
      ],
      onAccept: `
                // we grant analytics storage
                gtag('consent', 'update', {
                    'analytics_storage': 'granted',
                })
            `,
      onDecline: `
                // we deny analytics storage
                gtag('consent', 'update', {
                    'analytics_storage': 'denied',
                })
            `,
    },
    {
      name: 'google-ads',
      purposes: ['ads'],
      cookies: [],
      translations: {
        zz: {
          title: 'Google Ads tracking and personalization'
        },
      },
      onAccept: `
                gtag('consent', 'update', {
                    'ad_storage': 'granted', 'ad_user_data': 'granted', 'ad_personalization': 'granted'
                })
            `,
      onDecline: `
                gtag('consent', 'update', {
                    'ad_storage': 'denied', 'ad_user_data': 'denied', 'ad_personalization': 'denied'
                })
            `,
    },
    {
      name: 'linkedin',
      purposes: ['analytics'],
    },
    {
      name: 'leadForensics',
      purposes: ['analytics'],
      translations: {
        zz: {
          title: 'Lead Forensics'
        },
      },
    },
    {
      name: 'facebook',
      purposes: ['analytics'],
      translations: {
        zz: {
          title: 'Facebook'
        },
      },
    },
    {
      name: 'hubspot',
      purposes: ['analytics'],
      translations: {
        zz: {
          title: 'Hubspot'
        },
      },
    },
    {
      name: 'hotjar',
      purposes: ['analytics'],
      translations: {
        zz: {
          title: 'Hotjar'
        },
      },
    },
  ]
}

const dialog = document.documentElement.getAttribute('data-dialog');

if (dialog === 'us') {
  klaroConfig.privacyPolicy.default = '/us/privacy';
  klaroConfig.cookieName = 'klaro_us';
  klaroConfig.hideDeclineAll= true;

  klaroConfig.services.push({
    name: 'zoominfo',
    purposes: ['analytics'],
    translations: {
      zz: {
        title: 'ZoomInfo'
      },
    },
  });

  klaroConfig.services.push({
    name: 'chat',
    purposes: ['content'],
    translations: {
      zz: {
        title: 'Chat'
      },
    },
  });

  klaroConfig.services.push({
    name: 'call',
    purposes: ['analytics'],
    translations: {
      zz: {
        title: 'Call Tracking Metrics'
      },
    },
  });

  klaroConfig.services.push({
    name: 'lead',
    purposes: ['analytics'],
    translations: {
      zz: {
        title: 'Lead Tracker'
      },
    },
  });
}

window.klaro = Klaro;
window.klaroConfig = klaroConfig;
Klaro.setup(klaroConfig);
